export default function Reducer(prevState, action){
    switch (action.type) {
        case "LOADING":
            return {
                ...prevState,
                is_loading: true
            };
        case "LOADED":
            return {
                ...prevState,
                is_loading: false
            };
        case "OPEN":
            return {
                ...prevState,
                show: true
            };
        case "CLOSE":
            return {
                ...prevState,
                show: false
            };
        case "SET_JOB_ID":
            return {
                ...prevState,
                job_id: action.job_id,
                show: true,
                request_status: 'PENDING'
            };
        case "SET_JOB_DETAILS":
            return {
                ...prevState,
                job_details: action.job_details,
                is_show_remedial_job_details: true,
                is_loading: false,
                request_status: 'PENDING'
            };
        case "APPROVE_REQUEST":
            return {
                ...prevState,
                request_status: "APPROVE",
                is_loading: false
            };
        case "REJECT_REQUEST":
            return {
                ...prevState,
                request_status: "REJECT",
                is_loading: false
            };
        default:
            throw new Error();
    }
}